// Single source of truth for the advertised free-model catalog size.
//
// Keep in sync with the backend AVAILABLE_MODELS registry (what /api/models
// serves). Two consumers:
//   1. Runtime UI — useModelCount() fetches the LIVE count from /api/models and
//      uses these as the pre-fetch fallback (also what SEO crawlers see).
//   2. Static copy — i18n strings use {{MODELS}} / {{PROVIDERS}} (resolved
//      globally via i18next interpolation.defaultVariables), and the SEO
//      prerender substitutes the same tokens into the static marketing HTML.
//
// Update ONLY here when the catalog changes → every number across the app +
// SEO follows. Never hardcode a raw count in copy again (cf. the 2026-08 audit
// where "29" had drifted to ~24 live — MODEL_HEALTH.md / reference_model_catalog_liveness).
export const MODEL_COUNT = 24;
export const PROVIDER_COUNT = 7;

export const MODEL_STATS = { models: MODEL_COUNT, providers: PROVIDER_COUNT };

// Resolve {{MODELS}} / {{PROVIDERS}} in a string. i18next interpolation handles
// these in normal t() calls (via defaultVariables), but NOT in t(key,
// {returnObjects:true}) results — those come back raw. Use deepWithStats on any
// returnObjects payload (blog.posts, kits.list) so the tokens never leak.
export const withStats = (s) =>
  typeof s === "string"
    ? s
        .split("{{MODELS}}")
        .join(MODEL_COUNT)
        .split("{{PROVIDERS}}")
        .join(PROVIDER_COUNT)
    : s;

export const deepWithStats = (value) => {
  if (typeof value === "string") return withStats(value);
  if (Array.isArray(value)) return value.map(deepWithStats);
  if (value && typeof value === "object") {
    const out = {};
    for (const k of Object.keys(value)) out[k] = deepWithStats(value[k]);
    return out;
  }
  return value;
};
